import React from 'react';
import { Container, Row} from 'react-bootstrap';
import miniProjects from '../../../Data/miniProjects';
import './Portfolio.css';
import Works from './Works/Works';

const Portfolio = () => {
    const work = miniProjects;
    return (
        <>
            <section className="all-works">
                <Container>
                    <div className="text-center text-light py-5">
                        <h1>Most Popular Projects</h1>
                    </div>
                    <Row className="pb-4">
                        {
                            work.map(works => <Works key={works.id} works={works}></Works>)
                        }
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Portfolio;